// extracted by mini-css-extract-plugin
export default {"wrapper":"EmailList__wrapper--2zXfwS","title":"EmailList__title--MM9i89","list":"EmailList__list--TipRzA"};